import type { Order } from '@klear/order'
import { Combobox } from '@klear/ui/components/combobox'
import { PlusIcon } from 'lucide-react'
import { useCustomers } from '@klear/customer-ui/use-customers'
import { PERMISSION_ENTITY_ORDER, PERMISSION_ACTION_ADD } from '@klear/constants'
import { useAuth } from '@klear/ui/contexts/auth-context'
import { useParams } from 'react-router'
import { useOrderMutations } from '@klear/ui/hooks/use-order'
import isNumber from 'lodash/isNumber'
import toString from 'lodash/toString'
import toInteger from 'lodash/toInteger'

interface AddOrderProps {
  onSuccess?: (order: Order) => void
}

export default function AddOrder({ onSuccess }: AddOrderProps) {
  const { user } = useAuth()
  const { traderId } = useParams()
  const { customers } = useCustomers(toInteger(traderId))
  const { createOrder, isCreating } = useOrderMutations()

  if (!user?.hasPermission(PERMISSION_ENTITY_ORDER, PERMISSION_ACTION_ADD)) {
    return null
  }

  const customerOptions = customers
    .filter((customer) => isNumber(customer.id))
    .map((customer) => ({
      value: toString(customer.id),
      label: customer.name
    }))

  const onChange = async (customerId: string) => {
    try {
      const result = await createOrder({ customerId: parseInt(customerId), traderId: toInteger(traderId) })
      if (result) {
        onSuccess?.(result)
      }
    } catch (err) {
      console.error('Error creating order:', err)
    }
  }

  return (
    <div>
      <Combobox
        triggerIcon={<PlusIcon className="mr-2 h-4 w-4" />}
        triggerLabel="Add Order"
        placeholder="Search Customers..."
        options={customerOptions}
        onChange={onChange}
        disabled={isCreating}
      />
    </div>
  )
}
